// extracted by mini-css-extract-plugin
export default {"favorited":"FavoriteButton_favorited__O4WES"};